import { useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import Button from '../common/Button.react';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
var PpcClientDelete = function PpcClientDelete(_ref) {
  var client = _ref.client;
  var _useParams = useParams(),
    app = _useParams.app;
  var dispatch = useDispatch();
  return /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Delete Client"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    onClick: function onClick() {
      dispatch({
        type: ppcActions.clients,
        payload: {
          formData: {
            clientID: client._id,
            apiID: 'remove-client'
          },
          method: 'delete'
        }
      });
    },
    style: {
      width: 120
    },
    requireConfirmation: true,
    type: "close",
    apiID: "remove-client",
    permission: "edit-pos-sections"
  }))));
};
export default PpcClientDelete;